module.exports = __webpack_public_path__ + "static/media/LFEX-icon.207fefd0.png";